import React, {useEffect, useState} from 'react';
import {FormInstance, Steps} from 'antd';
import {ArrowLeftRight, FolderClosed} from "lucide-react";
import '../../../styles/component/deactivate-employee/deactive-employee.scss'
import HandleAsset from "./tabs/handle-asset/handle-asset";
import HandleReportees from "./tabs/handle-reportees/handle-reportees";
import {IItem} from "../search/utils/interface";

interface IDeactivateEmployeeStepperProps {
    reportees: any[];
    selectedRecord: IItem | null;
    modalForm: FormInstance;
    data: IItem[];
    setData: React.Dispatch<React.SetStateAction<IItem[]>>;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    getAllReportees: (record: IItem) => Promise<void>;
}

const items = [
    {
        key: '1',
        title: 'Transfer Reportees',
        icon: <ArrowLeftRight className={'deactivate-employee-stepper transfer-icon'}/>,
    },
    {
        key: '2',
        title: 'Handle Assets',
        icon: <FolderClosed className={'deactivate-employee-stepper folder-icon'}/>,
    },
];

const DeactivateEmployeeStepper = (props: IDeactivateEmployeeStepperProps) => {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        setCurrent(0);
    }, [props.selectedRecord?.id]);

    return (
        <div className={'employee-deactivate-stepper-wrapper'}>
            <Steps
                current={current}
                items={items}
            />

            <div>
                {current === 0 &&

                <HandleReportees
                    reportees={props.reportees}
                    selectedRecord={props.selectedRecord}
                    modalForm={props.modalForm}
                    setIsModalOpen={props.setIsModalOpen}
                    onContinue={() => setCurrent(1)}
                    getAllReportees={props.getAllReportees}
                />
                }

                {current === 1 &&
                <HandleAsset
                    selectedRecord={props.selectedRecord}
                    onBack={() => setCurrent(0)}
                    setIsModalOpen={props.setIsModalOpen}
                    data={props.data}
                    setData={props.setData}
                    modalForm={props.modalForm}
                />}
            </div>
        </div>
    )
}

export default DeactivateEmployeeStepper;